export default __webpack_public_path__ + "static/media/search_white.4b099fca.svg";